export default __webpack_public_path__ + "static/media/pic9.366b0e60.jpg";